import React from "react";
import "./SupportDepartment.scss";
import SupportDepartmentIState from "./SupportDepartment.models";
import SupportDepartmentImage from "../../../assest/images/CardViewBound02.png";
import SupportDepartmentService from "../../../services/supporter/SupportDepartmentService";
import CommingSoonModal from "../../shared/comming-soon-modal/CommingSoonModal";
import SupportUserService from "../../../services/management/SupportUserService";
import { GroupUser } from "../../../models/interfaces/management/GroupUser";
import { toast } from "react-toastify";
import SupportDepartementModal from "../support-department-modal/SupportDepartementModal";

export default class SupportDepartment extends React.PureComponent<{}, SupportDepartmentIState> {
  supportDepartmentService: SupportDepartmentService;
  supportUserService: SupportUserService;
  constructor(props: any) {
    super(props);
    this.supportDepartmentService = new SupportDepartmentService();
    this.supportUserService = new SupportUserService();

    this.state = {
      supportDepartments: [],
      staffs: [{ title: "مشاور", value: GroupUser.Assistant }, { title: "پشتیبان", value: GroupUser.Supporter },
      { title: "روانشناس", value: GroupUser.Psychologist }, { title: "رتبه برتر", value: GroupUser.Top_Student }, { title: "واحد نظارت", value: GroupUser.Supper_Admin }],
      showModal: false,
      selectedStaff: GroupUser.Assistant,
      showTitleModal: false,
    };
  }

  componentDidMount() {
    let self = this;
    self.supportDepartmentService.getTitleValue().then(function (response) {
      self.setState({ supportDepartments: response });
    });
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  showModal = () => {
    this.setState({ showModal: true });
  }

  contactWithStaff = (title: string, staff: GroupUser) => {
    this.supportUserService.requestStaff({ description: title, staff: staff }).then(response => {
      this.setState({ showTitleModal: false })
      toast.success('درخواست با موفقیت ثبت شد.');
    })
      .catch(error => {
        toast.error('ثبت درخواست با خطا مواجه شد.');
      });
  }

  openModal = (staff: GroupUser) => {
    this.setState({ selectedStaff: staff, showTitleModal: true });
  }

  render(): React.ReactNode {
    let self = this;
    let { staffs, showModal } = this.state;
    return (
      <>
        <div className="department-area">
          {staffs != null ? (
            <>
              {staffs.map(function (department, key) {
                return (
                  <div className="image-bottom" onClick={() => self.openModal(department.value)} key={key}>
                    <img src={SupportDepartmentImage} alt="" />
                    <label>ارتباط با {department.title}</label>
                  </div>
                  // <NavLink key={key} to={"/TicketEdition?inComing=" + department.id}>
                  //   <div className="image-bottom">
                  //     <img src={SupportDepartmentImage} alt="" />
                  //     <label>ارتباط با {department.title}</label>
                  //   </div>
                  // </NavLink>
                );
              })}
            </>
          ) : (<></>)}
          {/* <div className="image-bottom" onClick={() => self.showModal()}>
            <img src={SupportDepartmentImage} alt="" />
            <label>لیست تیکت ها</label>
          </div> */}
        </div>
        {/* <NavLink to={"/TicketList"}> 
        </NavLink> */}
        <CommingSoonModal closeModal={this.closeModal} showModal={showModal} />
        <SupportDepartementModal showModal={this.state.showTitleModal} onHandleClose={() => this.setState({ showTitleModal: false })}
          onHandleRequest={this.contactWithStaff} staff={this.state.selectedStaff} />
      </>
    );
  }
}
